import { cn } from "ui";
import { SkeletonButton } from "../primitives/SkeletonButton";
import { SkeletonField } from "../primitives/SkeletonField";

type FormSkeletonProps = {
  /** Number of field placeholders to render. */
  fields?: number;
  /** Number of action buttons in the footer. */
  actions?: number;
  className?: string;
};

export const FormSkeleton = ({
  fields = 5,
  actions = 2,
  className,
}: FormSkeletonProps) => (
  <div className={cn("flex flex-1 flex-col", className)}>
    <div className="flex flex-1 flex-col gap-4 p-8">
      {Array.from({ length: fields }).map((_, i) => (
        <SkeletonField key={i} />
      ))}
    </div>

    <div className="flex justify-end gap-3 border-t border-foundations-subtle p-4">
      {Array.from({ length: actions }).map((_, i) => (
        <SkeletonButton key={i} />
      ))}
    </div>
  </div>
);
